
<mat-form-field appearance="outline" [floatLabel]="'always'">

  <mat-label [id]="idPrefix + '-label'">{{label}}</mat-label>
  <mat-select #select
              hideSingleSelectionIndicator="true"
              lcTestId matInput
              [attr.aria-owns]="aria"
              [errorStateMatcher]="matcher"
              [formControl]="formControl"
              [id]="idPrefix + '-input'"
              [placeholder]="placeholder"
              (selectionChange)="onSelectionChanged($event)"
  >
    @if (emptyOptionDisplay) {
      <mat-option [class.disabled-option]="emptyOptionDisabled"
                  [disabled]="!!emptyOptionDisabled"
                  [value]="emptyOptionValue"
      >
        {{ emptyOptionDisplay }}
      </mat-option>
    }

    <mat-select-trigger>
      @if (selected && displayTemplate) {
        <ng-template
          [ngTemplateOutlet]="displayTemplate"
          [ngTemplateOutletContext]="{item: selected.model}" />
      } @else {
        {{selected?.label || placeholder }}
      }

    </mat-select-trigger>

    @for (option of dropdownOptions; track option) {
      <mat-option [disabled]="disabledPath && option?.value[disabledPath]"
        [id]="option.id" [lcTestId]="option" [ngClass]="{ 'line-height-unset': optionTemplate }" [value]="option.value">
        @if (select.panelOpen) {
          @if (optionTemplate || displayTemplate) {
            <ng-container
              [ngTemplateOutlet]="optionTemplate || displayTemplate"
              [ngTemplateOutletContext]="{item: option.model}" />
          } @else {
            <span class="option-title">{{option.label}} </span>
          }
        } @else {
          @if (displayTemplate) {
            <ng-container
              [ngTemplateOutlet]="displayTemplate"
              [ngTemplateOutletContext]="{item: option.model}" />
          } @else {
            <span class="option-title">{{option.label}} </span>
          }
        }
      </mat-option>
    }

  </mat-select>
  <mat-hint [id]="idPrefix + '-hint'">{{hint}}</mat-hint>
  @if (formControl && formControl.invalid) {
    <mat-error [id]="idPrefix + '-error'"
      [innerHTML]="errors" />
  }

  <!-- Fake input used to handle autofill changes. Needs to hide behind the screen. display: none does not work -->
  <input class="hidden-autofill-input" lcTestId matInput tabindex="-1"
    [formControl]="formControl" (change)="onAutoFill($event)">

</mat-form-field>
